<template>
  <v-layout row justify-center>
    <v-dialog :value="dialogStatus"  @input="$emit('input')" max-width="500px">
      <v-card>
        <v-card-title class="py-4">
          <div class="title">{{ $t('subscription.usage.headline') }}</div>
          <div class="body-1 py-1 grey--text text--darken-3">{{$t("subscription.usage.subheading")}}</div>
        </v-card-title>
        <v-card-text class="pa-0">
            <v-layout wrap>
              <v-flex xs12>
                  <v-data-table
                    :items="usage"
                    :headers="headers"
                    hide-actions
                    v-if="usage.length"
                  >
                  <template v-slot:items="props">
                    <td class="body-2">{{ moment.utc(props.item.date).local().format("D MMM, HH:MM") }}</td>
                    <td class="body-2 text-xs-right">{{ props.item.storage }}&nbsp;{{ $t('subscription.gb')}}</td>
                  </template>
                </v-data-table>
                <div v-else class="text-xs-center py-3">
                  <v-icon x-large color="grey" class="py-2">$vuetify.icons.rms_meter</v-icon>
                  <div class="subheading grey--text text--darken-2">{{ $t('subscription.usage.no_usage_found') }}</div>
                  <div class="grey--text text--darken-1">{{ $t('subscription.usage.no_usage_message') }}</div>
                </div>
              </v-flex>
            </v-layout>
        </v-card-text>
        <v-divider v-if="usage.length"></v-divider>
        <v-card-actions class="pt-4">
          <v-spacer></v-spacer>
          <v-btn color="grey " outline @click="dialogStatus = false">{{$t('subscription.payment.edit.button.close.title')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex';
import i18n from '@/i18n';

export default {
  props:['usage_visible'],
  data:()=>({
    headers: [
          { text: i18n.t("subscription.usage.date"), align: 'left', sortable: false, value: 'date' },
          { text: i18n.t("subscription.usage.units_used"),align: 'right',sortable: false, value: 'units' }
        ]
  }),
  computed:{
    ...mapState({
        usage:state => state.adminSubscription.usage
    }),
    dialogStatus:{
      get() {
          return this.usage_visible
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
}
</script>
